/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ColorObject, getColor } from 'jotai/vehicleColor';
import { LocalVehicleSelectionsAllPlayoffDrivers } from './LocalVehicleSelectionsObject';

const playoffDriversColors: Record<LocalVehicleSelectionsAllPlayoffDrivers, ColorObject> = {
  0: getColor('0', 'vehicle') as ColorObject, // none
  4: getColor('9', 'vehicle') as ColorObject, //top 4 for all series
  8: getColor('17', 'vehicle') as ColorObject, // top 8 for all series
  10: getColor('10', 'vehicle') as ColorObject, // top 10 for truck
  12: getColor('10', 'vehicle') as ColorObject, // top 12 for xfinity & cup
  16: getColor('26', 'vehicle') as ColorObject, // top 16 only for cup
};

export const getPlayoffDriversColor = (playoffDrivers: LocalVehicleSelectionsAllPlayoffDrivers): ColorObject => {
  return { ...playoffDriversColors[playoffDrivers] };
};
